// import { createSelector } from 'reselect';

export const getPassword = state => state.getIn(['resetPasswordWithToken', 'password']);
export const getConfirmPassword = state => state.getIn(['resetPasswordWithToken', 'confirmPassword']);
export const getIsReset = state => state.getIn(['resetPasswordWithToken', 'isReset']);
export const getErrMessage = state => state.getIn(['resetPasswordWithToken', 'errMessage']);

